import CheckoutCollapsibleStepper from './CheckoutCollapsibleStepper';

export default CheckoutCollapsibleStepper;
